import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Form, Card, Button } from "react-bootstrap";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../App";
import { postReservation } from "../../utils/api";
import "./../../components/button/button.css";
import "./../../components/background/background.css";
import "react-datepicker/dist/react-datepicker.css";
import Error from "../error/error";
import Image from "../../assets/background.png";
import Header from "../../components/header/header";
import Swal from "sweetalert2";
import { authentication } from "../../utils/config";
import { getUser } from "../../utils/api";
import ImageBack from "../../assets/back.png";
import mapping from "../../utils/areaMapping";
import "./reservation.css";

const Reservation = () => {
  const navigate = useNavigate();
  const lineProfile = useContext(AuthContext);
  const [formData, setFormData] = useState({
    type: "吸唾機",
    date: "",
    time: "",
    remark: "",
    clinicName: "",
    address: "",
    areaId: "",
  });

  useEffect(() => {
    let flag = true;

    // check line account
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
      else if(response.data.clinic.vip === false) {
        await Swal.fire({
          title: "登錄產品後即可使用",
          icon: "warning",
        }) ;
        return navigate("/main") ;
      }
      flag = false;
    };

    const getUserFunction = async () => {
      if (flag) return;
      const response = await getUser(lineProfile);
      if (response.error) {
        await Swal.fire({
          title: "系統錯誤",
          text: JSON.stringify(response.data),
          icon: "error",
        });
      } else if (response.data === "not found the user") {
        await Swal.fire({
          title: "帳號不存在",
          text: "請註冊帳號",
          icon: "error",
        });
      } else {
        const { address, name, areaId } = response.data.clinic;
        setFormData((prevData) => {
          return {
            ...prevData,
            clinicName: name,
            address: address,
            areaId: areaId,
          };
        });
      }
    };

    const combine = async () => {
      await auth();
      await getUserFunction();
    };
    combine();
  }, []);

  function isDateAfterToday(dateString) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
    const day = String(today.getDate()).padStart(2, '0');
    const now = `${year}-${month}-${day}` ;
    return dateString > now;
  }

  const handleReservation = async () => {
    let response;
    if (!(formData.date && formData.time && formData.type)) {
      response = {
        error: false,
        data: "inputs haven't completed yet",
      }
    
    }else if(!isDateAfterToday(formData.date)){
      response= {
        error: false,
        data: "today",
      }

    } else {
      response = await postReservation(lineProfile, formData);
    }

    if (response.error) {
      await Swal.fire({
        title: "系統錯誤",
        text: JSON.stringify(response.data),
        icon: "error",
      });
    } else if (response.data === "inputs haven't completed yet") {
      await Swal.fire({
        title: "格式錯誤",
        text: "資料輸入不完整或是格式錯誤",
        icon: "warning",
      });
    }else if(response.data === "today"){
      await Swal.fire({
        title: "日期錯誤",
        icon: "error",
      });
    } else if (response.data === "not found the user") {
      await Swal.fire({
        title: "帳號不存在",
        text: "請註冊帳號",
        icon: "error",
      });
    } else if (response.data === "reserv fail") {
      await Swal.fire({
        title: "預約失敗",
        text: "請重新嘗試或聯絡客服",
        icon: "error",
      });
    } else {
      await Swal.fire({
        title: "預約成功",
        icon: "success",
      });
      navigate(
        `/reservsuccess?type=${formData.type}&time=${formData.time}&date=${formData.date}&address=${formData.address}&clinicName=${formData.clinicName}&areaId=${formData.areaId}&address=${formData.address}`,
        { replace: true }
      );
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      console.log(updatedData);
      return updatedData;
    });
  };

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1); 
  const minDate = tomorrow.toISOString().split("T")[0];

  return (
    <Container
      fluid
      className=" d-flex flex-column  align-items-center backgroundStyle"
      style={{ backgroundImage: `url(${Image})`, overflow: "auto" }}
    >
      <div className="mt-3 w-100">
      <Header title="預約保養" className="mt-3">
        <img
          src={ImageBack}
          alt="Back"
          style={{ width: "20px", objectFit: "contain" }}
        />
      </Header>
      </div>
      <Card
        className="shadow p-3 reservation-card "
      >
        <Card.Body
         
        >
          <Form>
            <Form.Group className="reservation-form-margin">
              <Form.Label>欲保養項目</Form.Label>
              <Form.Select
                aria-label="Default select example"
                name="type"
                required="true"
                onChange={handleChange}
              >
                <option value="吸唾機">吸唾機</option>
                <option value="空壓機">空壓機</option>
                <option value="口外飛沫設備">口外飛沫設備</option>
                <option value="假牙製作台">假牙製作台</option>
                <option value="石膏沉澱箱/集塵箱">石膏沉澱箱/集塵箱</option>
                <option value="RO機">RO機</option>
                <option value="空氣過濾器">空氣過濾器</option>
                <option value="感控設備(消毒鍋、震盪機等)">
                  感控設備(消毒鍋、震盪機等)
                </option>
                <option value="攜帶式牙科診療設備">攜帶式牙科診療設備</option>
                <option value="其他(備註說明)">其他(備註說明)</option>
              </Form.Select>
            </Form.Group>

            <Form.Group
              className="reservation-form-margin"
              controlId="formBasicPassword"
            >
              <Form.Label>欲保養日期</Form.Label>
              <Form.Control
                type="date"
                placeholder="請選擇日期"
                name="date"
                required
                min={minDate}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group
              className="reservation-form-margin"
              controlId="formBasicPassword"
            >
              <Form.Label>時段選擇</Form.Label>
              <Form.Select
                aria-label="Default select example"
                required="true"
                name="time"
                onChange={handleChange}
              >
                <option value="aaa" disabled selected>
                  請選擇時間
                </option>
                <option value="09:00:00">9:00</option>
                <option value="09:30:00">9:30</option>
                <option value="10:00:00">10:00</option>
                <option value="10:30:00">10:30</option>
                <option value="11:00:00">11:00</option>
                <option value="11:30:00">11:30</option>
                <option value="12:00:00">12:00</option>
                <option value="12:30:00">12:30</option>
                <option value="13:00:00">13:00</option>
                <option value="13:30:00">13:30</option>
                <option value="14:00:00">14:00</option>
                <option value="14:30:00">14:30</option>
                <option value="15:00:00">15:00</option>
                <option value="15:30:00">15:30</option>
                <option value="16:00:00">16:00</option>
                <option value="16:30:00">16:30</option>
                <option value="17:00:00">17:00</option>
              </Form.Select>
            </Form.Group>

            <Form.Group
              className="reservation-form-margin"
              controlId="formBasicPassword"
            >
              <Form.Label>備註</Form.Label>
              <Form.Control
                name="remark"
                required="true"
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
      <Card
        
        className="shadow p-3 reservation-second-card"
      >
        <Form>
          <Form.Group
            className="reservation-form-margin"
            controlId="formBasicPassword"
          >
            <div className="reservation-input-width mx-auto">
              <Form.Control disabled={true} value={formData.clinicName} />
            </div>
          </Form.Group>

          <Form.Group
            className="reservation-form-margin"
            controlId="formBasicPassword"
          >
            <div className="reservation-input-width mx-auto">
              <Form.Control
                disabled={true}
                value={`${mapping[formData.areaId]} ${formData.address}`}
              />
            </div>
          </Form.Group>
        </Form>
      </Card>
      <br></br>
      <div
        className="d-flex  justify-content-center mx-4 mt-2 reserv-btn-margin"
        style={{ width: "60%" }}
      >
        <Button
          className="btn-custom-green me-3"
          style={{ height: "50px", width: "50%" }}
          onClick={handleReservation}
        >
          預約
        </Button>
        <Button
          className="btn-custom-white"
          style={{ height: "50px", width: "50%" }}
          onClick={() => {
            if (window.history.length <= 1) navigate("/main");
            else navigate(-1);
          }}
        >
          取消
        </Button>
      </div>
    </Container>
  );
};

export default Reservation;
